export interface InfoLine {
    id: string;
    message: string;
    startDate: string;
    endDate: string;
  }
  
  export const infoLines: InfoLine[] = [
    {
      id: "new-year-sale-2026",
      message: "Get 26% off on premium tiers using the code THRIVE26.",
      startDate: "2025-12-28T00:00:00",
      endDate: "2025-12-31T23:59:59",
    },
  ];